export default __webpack_public_path__ + "static/media/welcome-activity-feed.f77f2f61.png";